<template>
  <div class="query-list-container">
    <!-- 顶部导航栏 -->
    <el-row class="header-row">
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>

    <!-- 主体内容区域 -->
    <el-row class="main-content">
      <!-- 左侧菜单 -->
      <el-col :span="4" class="left-menu">
        <MenuList></MenuList>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="20" class="right-content">
        <!-- 顶部操作按钮 -->
        <div class="action-bar">
          <el-tooltip class="action-item" effect="dark" content="告诉您下一步怎么操作" placement="bottom">
            <el-button
              type="danger"
              @click="whatIsNextStep()"
              icon="el-icon-question"
              class="action-button">
              表格导入后下一步怎么让人查询？
            </el-button>
          </el-tooltip>
          <el-tooltip class="action-item" effect="dark" content="手上已经有表格,制表有点麻烦,直接导入吧" placement="bottom">
            <el-button
              type="primary"
              @click="importExcel()"
              icon="el-icon-upload2"
              class="action-button">
              导入Excel
            </el-button>
          </el-tooltip>
        </div>

        <!-- 数据表格 -->
        <div class="table-container">
          <el-table
            border
            :data="tableData"
            stripe
            class="data-table"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle">
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="form_name" label="查询名称" min-width="200">
              <template slot-scope="scope">
                <div v-if="tableData[scope.$index].form_owner=='我的'" class="form-name-normal">
                  {{scope.row.form_name}}
                </div>
                <div v-else class="form-name-bold">
                  {{scope.row.form_name}}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="conditions" label="查询条件" width="160" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.conditions==''" type="danger" size="small">暂未设置</el-tag>
                <el-tag v-else type="success" size="small">{{scope.row.conditions}}</el-tag>
              </template>
            </el-table-column>

<!--            <el-table-column prop="conditions" label="是否公开查询条件内容" width="180" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.public_condition=='1'" type="danger" size="small">公开</el-tag>
                <el-tag v-else type="info" size="small">保密</el-tag>
              </template>
            </el-table-column> -->

<!--            <el-table-column prop="recieve_code" label="查询码" width="150" align="center">
              <template slot-scope="scope">
                <span class="query-code">{{scope.row.recieve_code}}</span>
              </template>
            </el-table-column> -->

            <el-table-column prop="submit_count" label="数据(条)" align="center" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.submit_count===0" class="empty-data">空表</span>
                <span v-else class="data-count">{{scope.row.submit_count}}</span>
              </template>
            </el-table-column>

            <el-table-column label="查询率(%)" width="130" align="center">
              <template slot-scope="scope">
                <el-progress
                  :percentage="getSearchedPercent(scope.row.total, scope.row.searched_count)"
                  :stroke-width="12"
                  :show-text="false"></el-progress>
                <span class="percent-text">{{getSearchedPercent(scope.row.total, scope.row.searched_count)}}%</span>
              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="创建时间" align="center" width="180">
              <template slot-scope="scope">
                <span class="create-time">{{scope.row.create_time}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="180" fixed="right">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <div v-if="tableData[scope.$index].form_owner=='我的'">
                    <el-button
                      @click.native.prevent="sendForm(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-share"></i>
                      发布查询
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      @click.native.prevent="browseData(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-view"></i>
                      浏览数据
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      @click.native.prevent="testQuery(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-position"></i>
                      测试查询
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      @click.native.prevent="resetQueryConditions(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-setting"></i>
                      重设查询条件
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      @click.native.prevent="editFormName(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-edit"></i>
                      修改查询名称
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      @click.native.prevent="editFormComment(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn">
                      <i class="el-icon-document"></i>
                      <span v-if="tableData[scope.$index].comment">修改查询说明</span>
                      <span v-else>添加查询说明</span>
                    </el-button>
                  </div>

                  <div v-if="tableData[scope.$index].form_owner=='我的'">
                    <el-button
                      @click.native.prevent="emptyForm(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn action-btn-danger">
                      <i class="el-icon-delete"></i>
                      清空数据
                    </el-button>
                  </div>

                  <div v-if="tableData[scope.$index].form_owner=='我的'">
                    <el-button
                      @click.native.prevent="deleteForm(scope.$index, tableData)"
                      type="text"
                      size="small"
                      class="action-btn action-btn-danger">
                      <i class="el-icon-remove-outline"></i>
                      删除查询
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <!-- 删除确认对话框 -->
    <el-dialog
      title="删除查询"
      :visible.sync="deleteFormConfirmDialogVisible"
      width="40%"
      class="confirm-dialog">
      <div class="dialog-content">
        <div class="warning-text">
          <i class="el-icon-warning"></i>
          删除后已经发放的查询将无法恢复,如确定要删除,请输入删除验证码.
        </div>
        <div class="verify-code">
          <span class="label">删除验证码：</span>
          <span class="code-display">{{random_num}}</span>
        </div>
        <div class="verify-input">
          <span class="label">请输入验证码：</span>
          <el-input
            v-model="tmp_random_num"
            placeholder="点这里输入验证码"
            class="code-input"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteFormConfirmDialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="deleteSelectedForm" type="danger" class="danger-btn">永久删除查询</el-button>
      </div>
    </el-dialog>

    <!-- 清空数据确认对话框 -->
    <el-dialog
      title="清空查询中的数据"
      :visible.sync="emptyFormConfirmDialogVisible"
      width="40%"
      class="confirm-dialog">
      <div class="dialog-content">
        <div class="warning-text">
          <i class="el-icon-warning"></i>
          清空后发放的二维码仍然有效，但查不到数据.如确定要清空,请输入清空验证码.
        </div>
        <div class="verify-code">
          <span class="label">清空验证码：</span>
          <span class="code-display">{{random_num}}</span>
        </div>
        <div class="verify-input">
          <span class="label">请输入验证码：</span>
          <el-input
            v-model="tmp_random_num"
            placeholder="点这里输入验证码"
            class="code-input"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptyFormConfirmDialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="emptySelectedForm" type="danger" class="danger-btn">永久清空数据</el-button>
      </div>
    </el-dialog>

    <!-- Excel文件下载对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="下载Excel文件"
      :visible.sync="downloadExcelDialogVisible"
      class="download-dialog">
      <div class="dialog-content">
        <div class="download-info">
          <i class="el-icon-success"></i>
          Excel文件已经生成,请点下载按钮下载。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadExcelDialogVisible=false" class="cancel-btn">关闭</el-button>
        <el-button @click="downloadExcel" type="primary" class="primary-btn">下载</el-button>
      </div>
    </el-dialog>

    <!-- Zip文件下载对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="下载压缩包文件"
      :visible.sync="downloadZipDialogVisible"
      class="download-dialog">
      <div class="dialog-content">
        <div class="download-info">
          <i class="el-icon-success"></i>
          <div v-if="current_packed_time!=''">
            系统中有您在{{current_packed_time}}生成的文件
          </div>
          <div v-else>
            压缩包文件已经生成,请点下载按钮下载。下载后用解压工具打开。
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadZipDialogVisible=false" class="cancel-btn">关闭</el-button>
        <el-button @click="downloadExistZip" type="primary" class="primary-btn">下载</el-button>
      </div>
    </el-dialog>

    <!-- 已有Zip文件下载对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="系统中已有成功导出的压缩包"
      :visible.sync="downloadExistZipDialogVisible"
      class="download-dialog">
      <div class="dialog-content">
        <div class="download-info" v-if="is_new_zip_file=='1'">
          <i class="el-icon-success"></i>
          压缩包中的数据完整,可以直接下载使用,请点击"下载已有文件"按钮下载.
        </div>
        <div class="download-warning" v-else>
          <i class="el-icon-warning"></i>
          压缩包较旧,请点击"重新导出并下载"按钮重新导出.
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadExistZipDialogVisible=false" class="cancel-btn">关闭</el-button>
        <el-button @click="downloadExistZip" type="primary" class="primary-btn">下载已有文件</el-button>
        <el-button @click="downloadNewZip" type="primary" class="primary-btn">重新导出并下载</el-button>
      </div>
    </el-dialog>

    <!-- PDF文件下载对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="下载PDF文件"
      :visible.sync="downloadPDFDialogVisible"
      class="download-dialog">
      <div class="dialog-content">
        <div class="download-info">
          <i class="el-icon-success"></i>
          PDF文件已经生成,请点下载按钮下载。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadPDFDialogVisible=false" class="cancel-btn">关闭</el-button>
        <el-button @click="downloadPDF" type="primary" class="primary-btn">下载</el-button>
      </div>
    </el-dialog>

    <!-- 发布查询对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="发布查询"
      :visible.sync="sendFormDialogVisible"
      width="50%"
      class="send-form-dialog">
      <div class="dialog-content">
        <div class="publish-method">
          <div class="method-title">
            <i class="el-icon-qr-code"></i>
            方法一、转发二维码
          </div>
          <div class="method-desc">
            在二维码上右键"图片另存为..."下载此查询的二维码,打印张贴或者在微信中转发二维码,查询人扫码查询.手机端在发布查询时可以直接转发二维码。
          </div>
          <div class="qrcode-display">
            <img :src="qrcode_filename" alt="查询二维码" />
          </div>
        </div>
        <div class="publish-method">
          <div class="method-title">
            <i class="el-icon-mobile-phone"></i>
            方法二、转发小程序
          </div>
          <div class="method-desc">
            在手机<span class="highlight">万能快查小程序</span>中点开这个查询,再点击"发布查询"下边点"转发到群",查询人只需点开小程序输入条件即可查询.
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendFormDialogVisible=false" type="primary" class="primary-btn">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下一步操作提示对话框 -->
    <el-dialog
      title="表格导好了,怎么让别人查询？"
      :visible.sync="howToNextStepDialogVisible"
      width="50%"
      class="help-dialog">
      <div class="dialog-content">
        <div class="step-list">
          <div class="step-item">
            <span class="step-number">1</span>
            <span class="step-text">扫下面的二维码打开"万能快查"小程序；</span>
          </div>
          <div class="step-item">
            <span class="step-number">2</span>
            <span class="step-text">在"发布查询"中找到刚发布的查询；</span>
          </div>
          <div class="step-item">
            <span class="step-number">3</span>
            <span class="step-text">点"发布查询"转发小程序或二维码让大家查询.</span>
          </div>
        </div>
        <div class="qrcode-section">
          <div class="qrcode-title">
            <i class="el-icon-warning"></i>
            微信扫码打开万能快查
          </div>
          <div class="qrcode-display">
            <img src="/wansearch/images/wansearch_qrcode.jpg" alt="万能快查二维码" />
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="howToNextStepDialogVisible = false" type="primary" class="primary-btn">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 邀请用户提示对话框 -->
    <el-dialog
      title="怎么让别人看到我发的表格？"
      :visible.sync="howToUseInviteFormDialogVisible"
      width="50%"
      class="help-dialog">
      <div class="dialog-content">
        <div class="step-list">
          <div class="step-item">
            <span class="step-number">1</span>
            <span class="step-text">打开您刚才扫码登录的小程序；</span>
          </div>
          <div class="step-item">
            <span class="step-number">2</span>
            <span class="step-text">在手机小程序上点开您想让他看到的表格；</span>
          </div>
          <div class="step-item">
            <span class="step-number">3</span>
            <span class="step-text">点击"邀请围观"把他邀请进来；</span>
          </div>
          <div class="step-item">
            <span class="step-number">4</span>
            <span class="step-text">他用小程序扫web网站上的登录二维码登录网页端就可以看到表格了。</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="howToUseInviteFormDialogVisible = false" type="primary" class="primary-btn">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 清空表数据确认对话框 -->
    <el-dialog
      title="清空表中的数据"
      :visible.sync="deleteFormDataConfirmDialogVisible"
      width="45%"
      class="confirm-dialog">
      <div class="dialog-content">
        <div class="danger-text">
          <i class="el-icon-error"></i>
          此操作会永久删除表格中的数据,是危险操作!删除后无法恢复,请慎重操作！
        </div>
        <div class="message-text">
          {{msg}}
        </div>
        <div class="verify-note">为了确保您不会误操作,请输入清空数据验证码!</div>
        <div class="verify-code">
          <span class="label">清空数据的验证码：</span>
          <span class="code-display">{{random_num}}</span>
        </div>
        <div class="verify-input">
          <span class="label">请输入清空验证码：</span>
          <el-input
            v-model="tmp_random_num"
            placeholder="点这里输入验证码"
            class="code-input"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteFormDataConfirmDialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="emptySelectedFormData" type="danger" class="danger-btn">清空表中的数据</el-button>
      </div>
    </el-dialog>

    <!-- 推广提示对话框 -->
    <el-dialog
      title="发成绩不用模板,查成绩不装软件--用快查成绩微信小程序!"
      width="50%"
      :visible.sync="shareDocDialogVisible"
      class="share-dialog">
      <div class="dialog-content">
        <div class="feature-list">
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span class="feature-text">成绩不能公开，但又需要发给家长，老师工作量太大，用这个就省事了！！</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span class="feature-text">微信小程序，不用装软件，不用关注，直接查完就走。</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-check"></i>
            <span class="feature-text">发成绩时用现成的成绩单就可以，不用再填模板，点点选选就导入了，简单易用。</span>
          </div>
        </div>
        <div class="qrcode-section">
          <div class="qrcode-title">
            <i class="el-icon-star-on"></i>
            立即用微信扫码体验
          </div>
          <div class="qrcode-display">
            <img src="/form/images/kuaicha_mp.jpg" alt="快查成绩小程序" />
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shareDocDialogVisible=false" type="primary" class="primary-btn">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 测试查询对话框 -->
    <el-dialog
      title="测试一下查询是否能正常使用"
      width="40%"
      :visible.sync="testQueryDialogVisible"
      class="test-dialog">
      <div class="dialog-content">
        <div class="qrcode-section">
          <div class="qrcode-title">
            <i class="el-icon-warning"></i>
            微信扫描下面的二维码打开查询
          </div>
          <div class="qrcode-display">
            <img :src="qrcode_filename" alt="查询二维码" />
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="testQueryDialogVisible=false" type="primary" class="primary-btn">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 修改查询名称对话框 -->
    <el-dialog
      title="修改查询名称"
      :close-on-click-modal="false"
      :visible.sync="editFormNameDialogVisible"
      width="40%"
      class="edit-dialog">
      <div class="dialog-content">
        <div class="edit-input">
          <span class="label">查询名称：</span>
          <el-input
            v-model="selectedFormName"
            placeholder="点这里输入查询名称"
            class="name-input"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormNameDialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="editFormNameSave" type="primary" class="primary-btn">保存</el-button>
      </div>
    </el-dialog>

    <!-- 查询说明对话框 -->
    <el-dialog
      title="查询说明"
      :close-on-click-modal="false"
      :visible.sync="editFormCommentDialogVisible"
      width="40%"
      class="edit-dialog">
      <div class="dialog-content">
        <div class="edit-textarea">
          <el-input
            type="textarea"
            :rows="5"
            v-model="selectedFormComment"
            placeholder="查询说明会显示在用户查询页面,主要是说明如何查询以及注意事项"
            class="comment-textarea"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormCommentDialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="editFormCommentSave" type="primary" class="primary-btn">保存</el-button>
      </div>
    </el-dialog>

    <!-- 重要提示对话框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="dialogVisible"
      width="30%"
      class="confirm-dialog">
      <div class="dialog-content">
        <div class="message-text">
          {{msg}}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel-btn">取消</el-button>
        <el-button @click="delFormContentRecord" type="danger" class="danger-btn">删除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,

        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',

        downloadPDFDialogVisible: false,
        howToNextStepDialogVisible: false,

        zip_file_form_id: '',

        howToUseInviteFormDialogVisible: false,
        deleteFormConfirmDialogVisible: false,

        random_num: '',
        tmp_random_num: '',

        current_packed_time: '',
        downloadExistZipDialogVisible: false,

        current_index: '',
        current_rows: '',
        current_pasted_minutes: '',

        is_new_zip_file: '0',

        deleteFormDataConfirmDialogVisible: false,

        shareDocDialogVisible: false,

        testQueryDialogVisible: false,
        qrcode_filename: '',

        emptyFormConfirmDialogVisible:false,

        editFormNameDialogVisible:false,
        selectedFormName:'',

        editFormCommentDialogVisible:false,
        selectedFormComment:''

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.loadDateList()
      this.loadData()
    },
    methods: {
      headerCellStyle() {
        return {
          background: '#f8f9fa',
          color: '#2c3e50',
          fontWeight: '600',
          fontSize: '13px'
        }
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        return {
          fontSize: '14px'
        }
      },
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/wansearch/web/_load_queries.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.tableData = response.data
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state

        if (typeof(state) === 'undefined' || state === 1) {
          return '未发放'
        }

        if (state === 2) {
          return '正在填写'
        }

        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages

        if (typeof(inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }

        if (inputPages > 1) {
          return '多张/人'
        }
      },

      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id

        // this.deleteFormConfirmDialogVisible = true

        this.position = index
        this.selected_form_id = rows[index].id

        var state = rows[index].state

        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！', '提示', {

            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })

          return
        }

        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,删除后已经发放的查询将无法查询，且无法恢复！'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }

        this.deleteFormConfirmDialogVisible = true

        // this.dialogVisible = true
      },
      emptyForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id

        // this.deleteFormConfirmDialogVisible = true


        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,清空后已经发放的查询将无法查询，且无法恢复，但此表的二维码仍然有效！'
        } else {
          this.msg = '确定要清空《' + rows[index].form_name + '》吗?'
        }

        this.emptyFormConfirmDialogVisible = true

        // this.dialogVisible = true
      },
      deleteSelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入删除验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('删除验证码不正确,请重新输入!')
        } else {

          this.delFormContentRecord()
        }

        //
      },
      delFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false

        // 调用删除接口
        var requestUrl = '/wansearch/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            // that.loadDateList()

            that.tmp_random_num = ''

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      emptySelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空验证码不正确,请重新输入!')
        } else {


          this.emptyFormContentRecord()
        }

        //
      },
      emptyFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false

        // 调用删除接口
        var requestUrl = '/wansearch/web/_empty_query_data.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.tmp_random_num = ''
            that.emptyFormConfirmDialogVisible=false

            that.$message.success('清除成功！')
            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },


      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        // this.$router.push('/import_excel'),
        // this.$router.push('/import_data_excel')

        this.$alert('请在左侧的菜单上选择导入方式！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton:false,
          callback: action => {
            this.function()
          }
        })

      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        this.current_packed_time = rows[index].packed_finish_time
        this.current_pasted_minutes = rows[index].pasted_minutes

        this.current_index = index
        this.current_rows = rows

        if (this.current_packed_time !== '') {
          this.showExistZipDialog(index, rows)
        } else {
          this.export(index, rows)
        }

        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = ''

        // var fileType = rows[index].file_type
        // if (fileType === 'EXCEL') {
        //   requestUrl = '/form/web/_export_to_excel.jsp'
        // } else if (fileType === 'ZIP') {
        //   requestUrl = '/form/web/_export_to_zip.jsp'
        // }

        // this.axios.get(requestUrl, {
        //   params: {
        //     username: that.username,
        //     form_id: formId
        //   }
        // }).then(function(response) {
        //   console.log(response)
        //   var fileName = ''
        //   if (fileType === 'EXCEL') {
        //     fileName = '/form/temp/' + formId + '.xls'
        //     that.downloadExcelDialogVisible = true
        //     that.current_download_file_name = fileName
        //   } else if (fileType === 'ZIP') {
        //     fileName = '/form/temp/' + formId + '.zip'
        //     that.downloadZipDialogVisible = true
        //     // that.current_download_file_name = fileName
        //     // that.current_download_file_name = response.data.download_file_path
        //     that.current_download_file_name = fileName

        //     that.zip_file_form_id = formId
        //   }

        //   load.close()
        // }).catch(function(error) {
        //   console.log(error)
        //   load.close()
        // })
      },
      showExistZipDialog(index, rows) {
        var selected_form_id = rows[this.current_index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_export_zip_state.jsp'

        this.axios.get(requestUrl, {
          params: {
            form_id: selected_form_id
          }
        }).then(function(response) {
          console.log(response)
          // var fileName = ''

          that.is_new_zip_file = response.data.is_new_zip

          that.downloadExistZipDialogVisible = true

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadExistZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        var selected_form_id = this.current_rows[this.current_index].id

        var url = '/form/download.jsp?form_id=' + selected_form_id
        // window.open(this.current_download_file_name)
        window.open(url)
      },
      export (index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = ''

        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            // that.current_download_file_name = fileName
            // that.current_download_file_name = response.data.download_file_path
            that.current_download_file_name = fileName

            that.zip_file_form_id = formId
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_export_to_pdf.jsp'

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true

          that.current_download_file_name = response.data.pdf_filename

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadNewZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        let that = this
        var formId = that.current_rows[that.current_index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        requestUrl = '/form/web/_export_to_zip.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)

          load.close()
          var fileName = ''
          fileName = '/form/temp/' + formId + '.zip'
          that.current_download_file_name = fileName
          var selected_form_id = that.current_rows[that.current_index].id
          var url = '/form/download.jsp?form_id=' + selected_form_id
          // window.open(this.current_download_file_name)
          window.open(url)
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id


        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/wansearch/web/_qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/wansearch' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.sendFormDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      browseData(index, rows) {
        // var formId = rows[index].id
        // var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        // window.open(url)

        var formId = rows[index].id
        var formName = rows[index].form_name

        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      openMakeForm() {
        this.$router.push('/make_form')
      },
      validCondition(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name

        console.log(rows[index])
        console.log(formId)
        console.log(formName)

        this.$router.push({
          name: 'set_valid_condition',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      whatIsNextStep() {
        this.howToNextStepDialogVisible = true
      },
      collectAdvice(index, rows) {
        // this.$message.info('adsfadf')
      },
      howToUseInviteForm() {
        this.howToUseInviteFormDialogVisible = true
      },
      emptyFormData(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.tmp_random_num = ''
        this.msg = '要清空《' + rows[index].form_name + '》的全部数据吗?'
        this.selected_form_id = rows[index].id
        this.deleteFormDataConfirmDialogVisible = true
      },
      emptySelectedFormData() {
        let that = this

        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空数据验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空数据验证码不正确,请重新输入!')
          return
        }

        // 调用删除接口
        var requestUrl = '/form/web/_empty_form_data.jsp'
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.deleteFormDataConfirmDialogVisible = false
            that.tmp_random_num = ''
            // that.tableData.splice(that.position, 1)
            that.loadData()

            that.$message.success('清空成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showShareDocDialog() {
        this.shareDocDialogVisible = true
      },
      getSearchedPercent(total, searched_count) {
        var percent = 0;

        if (total == 0) {
          percent = 0
        } else {
          // if(Utils.isEmpty(searched_count)){
          // 	searched_count=1
          // }
          percent = ((searched_count / total) * 100)
        }

        return percent.toFixed(1)
      },
      testQuery(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/wansearch/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/wansearch' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.testQueryDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      editFormName(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id
        this.selectedFormName = rows[index].form_name
        this.editFormNameDialogVisible = true
      },
      editFormNameSave() {
        if (Utils.isEmpty(this.selectedFormName)) {
          this.$message.error('名称不能为空！')
          return
        }

        let that = this

        // 调用删除接口
        var requestUrl = '/wansearch/web/_update_form_name.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              form_name: that.selectedFormName
            }
          }).then(function(response) {

            that.selectedFormName = ''
            that.selected_form_id = ''
            that.editFormNameDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })


      },

      editFormComment(index, rows){
        // console.log('%%%%%%%%%%%%%%%%%')
        this.position = index
        this.selected_form_id = rows[index].id
        this.selectedFormName = rows[index].form_name
        this.selectedFormComment=rows[index].comment
        this.editFormCommentDialogVisible = true
      },
      editFormCommentSave(){
        let that = this

        // 调用删除接口
        var requestUrl = '/wansearch/web/_update_form_comment.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              form_comment: that.selectedFormComment
            }
          }).then(function(response) {

            that.selectedFormName = ''
            that.selected_form_id = ''
            that.selectedFormComment=''
            that.editFormCommentDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      resetQueryConditions(index, rows){
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        this.$router.push({
          name: 'reset_query_conditions',
          params: {
            form_id: this.selected_form_id,
            form_name:this.selected_form_name
          }
        })
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
/* ==================== 页面容器 ==================== */
.query-list-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

/* ==================== 头部区域 ==================== */
.header-row {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* ==================== 主体内容区域 ==================== */
.main-content {
  padding: 20px;
}

.left-menu {
  padding-right: 15px;
}

.right-content {
  padding: 0 15px;
}

/* ==================== 操作按钮区域 ==================== */
.action-bar {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.action-button {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-button:active {
  transform: translateY(0);
}

/* ==================== 表格容器 ==================== */
.table-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  overflow: hidden;
}

.data-table {
  border-radius: 8px;
  overflow: hidden;
}

.data-table >>> .el-table__header-wrapper {
  border-radius: 8px 8px 0 0;
  border-bottom: 2px solid #e9ecef;
}

.data-table >>> .el-table__body-wrapper {
  border-radius: 0 0 8px 8px;
}

/* 表格行样式 */
.data-table >>> .el-table__row {
  transition: all 0.3s ease;
}

.data-table >>> .el-table__row:hover {
  background: rgba(0, 0, 0, 0.02);
}

.data-table >>> .el-table__row:nth-child(even) {
  background: #ffffff;
}

.data-table >>> .el-table__row:nth-child(even):hover {
  background: rgba(0, 0, 0, 0.02);
}

/* 表格单元格样式 */
.form-name-normal {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 400;
}

.form-name-bold {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 600;
}

.query-code {
  font-family: 'Courier New', monospace;
  font-weight: 500;
  color: #495057;
  font-size: 13px;
  letter-spacing: 1px;
}

.empty-data {
  color: #dc3545;
  font-weight: 500;
  font-size: 13px;
}

.data-count {
  font-weight: 500;
  color: #28a745;
  font-size: 13px;
}

.percent-text {
  font-size: 12px;
  color: #495057;
  font-weight: 500;
}

.create-time {
  font-size: 12px;
  color: #6c757d;
}

/* ==================== 操作按钮样式 ==================== */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.2s ease;
  width: 100%;
  color: #495057;
}

.action-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #212529;
}

.action-btn i {
  font-size: 14px;
}

.action-btn-danger {
  color: #dc3545;
}

.action-btn-danger:hover {
  background: rgba(220, 53, 69, 0.08);
  color: #dc3545;
}

/* ==================== 对话框通用样式 ==================== */
.confirm-dialog >>> .el-dialog,
.download-dialog >>> .el-dialog,
.send-form-dialog >>> .el-dialog,
.help-dialog >>> .el-dialog,
.test-dialog >>> .el-dialog,
.edit-dialog >>> .el-dialog,
.share-dialog >>> .el-dialog {
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.confirm-dialog >>> .el-dialog__header,
.download-dialog >>> .el-dialog__header,
.send-form-dialog >>> .el-dialog__header,
.help-dialog >>> .el-dialog__header,
.test-dialog >>> .el-dialog__header,
.edit-dialog >>> .el-dialog__header,
.share-dialog >>> .el-dialog__header {
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.confirm-dialog >>> .el-dialog__title,
.download-dialog >>> .el-dialog__title,
.send-form-dialog >>> .el-dialog__title,
.help-dialog >>> .el-dialog__title,
.test-dialog >>> .el-dialog__title,
.edit-dialog >>> .el-dialog__title,
.share-dialog >>> .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.confirm-dialog >>> .el-dialog__body,
.download-dialog >>> .el-dialog__body,
.send-form-dialog >>> .el-dialog__body,
.help-dialog >>> .el-dialog__body,
.test-dialog >>> .el-dialog__body,
.edit-dialog >>> .el-dialog__body,
.share-dialog >>> .el-dialog__body {
  padding: 20px;
}

.dialog-content {
  max-height: 60vh;
  overflow-y: auto;
}

/* ==================== 对话框内容样式 ==================== */
.warning-text {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: #e67e22;
  background: #fff7e6;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #e67e22;
  margin-bottom: 20px;
}

.warning-text i {
  font-size: 20px;
}

.danger-text {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: #e74c3c;
  background: #ffe6e6;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #e74c3c;
  margin-bottom: 20px;
}

.danger-text i {
  font-size: 20px;
}

.message-text {
  font-size: 15px;
  color: #2c3e50;
  line-height: 1.8;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.verify-note {
  font-size: 14px;
  color: #e74c3c;
  margin-bottom: 15px;
  padding: 10px;
  background: #fff5f5;
  border-radius: 6px;
}

.verify-code {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.verify-code .label {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  min-width: 140px;
}

.verify-code .code-display {
  font-family: 'Courier New', monospace;
  font-size: 24px;
  font-weight: 700;
  color: #e74c3c;
  background: #fff5f5;
  padding: 10px 20px;
  border-radius: 6px;
  border: 2px solid #e74c3c;
}

.verify-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.verify-input .label {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  min-width: 140px;
}

.verify-input .code-input {
  flex: 1;
}

.verify-input >>> .el-input__inner {
  font-size: 16px;
  border-radius: 6px;
  border: 2px solid #d9d9d9;
  transition: all 0.3s ease;
}

.verify-input >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

/* ==================== 下载对话框样式 ==================== */
.download-info,
.download-warning {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  line-height: 1.8;
  padding: 15px;
  border-radius: 8px;
}

.download-info {
  color: #27ae60;
  background: #e8f8f5;
  border-left: 4px solid #27ae60;
}

.download-warning {
  color: #e67e22;
  background: #fff7e6;
  border-left: 4px solid #e67e22;
}

.download-info i,
.download-warning i {
  font-size: 24px;
  flex-shrink: 0;
}

/* ==================== 发布查询对话框样式 ==================== */
.publish-method {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.method-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-title i {
  color: #667eea;
  font-size: 20px;
}

.method-desc {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 15px;
}

.method-desc .highlight {
  color: #e74c3c;
  font-weight: 600;
  padding: 0 4px;
}

/* ==================== 二维码样式 ==================== */
.qrcode-display {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.qrcode-display img {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 10px;
  background: #ffffff;
}

.qrcode-section {
  text-align: center;
  margin-top: 20px;
}

.qrcode-title {
  font-size: 16px;
  font-weight: 600;
  color: #e74c3c;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.qrcode-title i {
  font-size: 20px;
}

/* ==================== 步骤列表样式 ==================== */
.step-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 25px;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #4a5568;
  line-height: 1.6;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border-radius: 50%;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

/* ==================== 特性列表样式 ==================== */
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 25px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 15px;
  color: #4a5568;
  line-height: 1.6;
}

.feature-item i {
  color: #27ae60;
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.feature-text {
  flex: 1;
}

/* ==================== 编辑对话框样式 ==================== */
.edit-input,
.edit-textarea {
  margin-bottom: 20px;
}

.edit-input .label,
.edit-textarea .label {
  display: block;
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 10px;
}

.edit-input .name-input,
.edit-textarea .comment-textarea {
  width: 100%;
}

.edit-input >>> .el-input__inner,
.edit-textarea >>> .el-textarea__inner {
  font-size: 15px;
  border-radius: 8px;
  border: 2px solid #d9d9d9;
  transition: all 0.3s ease;
}

.edit-input >>> .el-input__inner:focus,
.edit-textarea >>> .el-textarea__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* ==================== 对话框底部按钮样式 ==================== */
.dialog-footer {
  padding: 15px 20px 20px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.danger-btn {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.danger-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
}

.cancel-btn {
  background: #f5f7fa;
  border: 1px solid #d9d9d9;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #e4e8eb;
  color: #2c3e50;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1200px) {
  .main-content {
    padding: 15px;
  }

  .action-bar {
    flex-wrap: wrap;
  }

  .data-table {
    font-size: 13px;
  }

  .action-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .left-menu {
    display: none;
  }

  .right-content {
    padding: 0;
  }

  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-button {
    width: 100%;
  }

  .table-container {
    padding: 10px;
  }

  .action-buttons {
    gap: 6px;
  }

  .qrcode-display img {
    width: 150px;
    height: 150px;
  }
}

@media (max-width: 480px) {
  .data-table {
    font-size: 12px;
  }

  .action-btn {
    font-size: 11px;
    padding: 4px 8px;
  }

  .qrcode-display img {
    width: 120px;
    height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/query_list.vue